import React from 'react';
import {Link} from "react-router-dom";
import "./style.css";

import angleDown from '../../../assets/images/angleDown@2x.png';

/*
export default (props)=> {
  return <MenuLateral{...MenuLateralData} />;
};
*/
function MenuLateral(props) {
  const {
    videoData,
    mundoData,
    p_mundo,
    p_fase,
    //userData,
    fuData,
  } = props;


  const mundoTitulo = mundoData.titulo,
  nFase = `${p_fase}/${mundoData.fases.length}`;

  const listadosComponents = mundoData.fases.sort((x,y)=>x.position-y.position).map((faseData,posi) => (
      <ListaCompo key={posi} faseData={faseData} posi={posi+1} p_mundo={p_mundo} p_fase={p_fase} fuData={fuData}/>
  ));

  function MenuOp(props){
      const {exibir}=props;
      //console.error("exibir:",exibir);
      if (!!exibir){
          return (
              <div className="menu-lateral">
                  <div className="menu-lateral-lista">
                    {/*  menu lateral HEADER    */}
                    <div className="menu-lateral-header">
                      <div className="auto-flex">
                        <h1 className="mundo-n valign-text-bottom roboto-bold-white">{mundoTitulo}</h1>
                        <div className="n-fase poppins-normal-mischka-18px">{nFase}</div>
                      </div>
                      <img alt="icon-seta" className="icon-seta" src={angleDown} />
                    </div>

                    {/*  menu lateral BODY    */}
                    <div className="fases-lista">
                      {listadosComponents}
                    </div>
                  </div>
              </div>
          )
      }
      return (<div></div>)
  }
  return (
      <MenuOp exibir = {videoData.mostrar_lista}/>
  );
}

export default MenuLateral;

function ListaCompo({faseData,posi, p_mundo, p_fase,fuData}) {
  let ico_stts = p_fase===posi ? 1:0;
  if (posi===p_fase){
      // fase em exibição
      ico_stts = 1
  } else if (posi<p_fase || fuData.some(fu =>fu.id===faseData.id)) {
      // 1 - fase que ele ja passou, no caso deixar como assistposio
      // 2 - fase do futuro que ele ja viu (ele ta revisando algo)
      ico_stts = 2
  } else {
      // se não assistiu e não ta assistindo, então ta bloqueado
      ico_stts = 0
  }

  //console.log("faseData",faseData)
  //console.log("posi",posi,"p_fase",p_fase)
  //console.log(".typeof","posi",typeof(posi),"p_fase",typeof(p_fase))
  //console.log("userData",userData)
  const txt_status = ["Bloqueado","Atual","Feito"][Number(ico_stts) ? ico_stts : 0]  || "Bloqueado"
  const titulo =    faseData.tipo==='aula' ? faseData.aula.titulo :
                    faseData.tipo==='quiz' ? 'Quiz':
                    faseData.tipo==='teste_final' ? 'Teste de Conhecimentos'
                    : 'coringa'
  return (
    <Link to={ico_stts===0 ? '#': `/planetas/${p_mundo}/${posi}`} className={ico_stts===0? "lista1 listaLock" : "lista1"}  title={txt_status}>
      <IcoListStts ico_stts={ico_stts}/>
      <div className="lista-text valign-text-middle roboto-bold-mercury-36px">{titulo}</div>
    </Link>
  );
}


function IcoListStts({ico_stts}) {

  const cor_status = ["e-opaco","e-laranja","e-verde"][Number(ico_stts) ? ico_stts : 0]  || "e-opaco"

  return (
    <div className="ico-list-video">
      <div className="e-eFundo">
        <div className={cor_status}/>
      </div>
    </div>
  );
}
